/**
 * Enum Đã sinh chứng từ
 * lttuan1 25.05.2023
 */
export default {
  All: -1,
  Planned: 1,
  NotPlanned: 0,
};
